<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_61821_14249" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<rect width="24" height="24" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_61821_14249)">
<path d="M13.0674 16.3389L13.0557 20.3506L6 16.6602V13.6699L13.0674 16.3389ZM15.1152 9.81836V13.9639L6 11.4971V8.32031L15.1152 9.81836ZM18.6162 3.32324V7.11719L6 6.23145V3.02344L18.6162 3.32324Z" stroke-width="2"/>
</g>
</svg>
